/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestCourse } from '../../models/request-course';

export interface ApiRequestCndnGetApplicationGet$Params {
}

export function apiRequestCndnGetApplicationGet(http: HttpClient, rootUrl: string, params?: ApiRequestCndnGetApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RequestCourse>>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCndnGetApplicationGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RequestCourse>>;
    })
  );
}

apiRequestCndnGetApplicationGet.PATH = '/api/Request/Cndn/GetApplication';
